<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex sm4>
        <div class="headline green--text text--darken-4 font-weight-medium">
          Print Address
        </div>
      </v-flex>
      <v-flex lg12 sm12 xs12>
        <v-card>
          <v-toolbar card prominent color="transparent">
            <v-btn class="mb-2" outline @click="goBack">
              <v-icon class="iconText">fa fa-angle-left</v-icon>
              &nbsp;&nbsp;Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" outline @click="showDlg">
              <v-icon class="iconText">fa fa-filter</v-icon>
              Filter Addresses
            </v-btn>
            <v-btn color="primary" outline @click="printAddress"
              ><v-icon class="iconText">fa fa-print</v-icon>Print</v-btn
            >
          </v-toolbar>
          <v-divider></v-divider>
        </v-card>
      </v-flex>
      <v-flex lg12 sm12 xs12>
        <v-card class="elevation-0">
          <v-card-text>
            <div id="addressDoc">
              <div v-for="(group, i) in PrintPrescriptions" :key="i">
                <PAddressV2 :prescriptions="group"></PAddressV2>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-dialog v-model="dlgShow" scrollable persistent max-width="400px">
          <v-card>
            <v-card-title>
              <div class="title font-weight-medium">
                Select addresses
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row wrap>
                <v-flex>
                  <v-btn flat @click="selectAll">Select All</v-btn>
                  <v-btn flat @click="selectNone">Select None</v-btn>
                </v-flex>
                <v-flex>
                  <v-list two-line class="permList">
                    <v-list-tile v-for="(item, i) in prescriptions" :key="i">
                      <v-list-tile-action>
                        <v-checkbox
                          color="primary"
                          v-model="item.Selected"
                        ></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content
                        @click="item.Selected = !item.Selected"
                      >
                        <v-list-tile-title>{{
                          item.Item.PatientId
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.Item.PatientName }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions
              ><v-spacer></v-spacer>
              <v-btn flat @click.native="closeDlg">Close</v-btn>
              <v-btn color="primary darken-1" flat @click.native="saveDlg"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PAddressV2 from "../../components/prescription/PAddressV2";
export default {
  components: {
    PAddressV2
  },
  created() {
    const prscs = this.$store.getters["PrscStore/prescriptions"];
    for (let i = 0; i < prscs.length; i++) {
      this.prescriptions.push({ Item: prscs[i], Selected: true });
    }
    this.selectedItems = prscs;
  },
  data() {
    return {
      dlgShow: false,
      prescriptions: [],
      selectedItems: []
    };
  },
  computed: {
    PrintPrescriptions() {
      let gLen = Math.floor(this.selectedItems.length / 8);
      const rem = this.selectedItems.length % 8;
      if (rem > 0) gLen++;
      const items = [];
      for (let i = 0; i < gLen; i++) {
        const nodes = [];
        const start = i * 8;
        let limit = 8;
        if (this.selectedItems.length <= start + 8)
          limit = this.selectedItems.length - start;
        for (let j = 0; j < limit; j++) {
          nodes.push(this.selectedItems[start + j]);
        }
        items.push(nodes);
      }
      return items;
    }
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    printAddress() {
      this.$htmlToPaper("addressDoc");
    },
    showDlg() {
      // for (let i = 0; i < this.prescriptions.length; i++) {
      //   const item = {
      //     It: this.prescriptions[i]
      //   };
      //   item.Selected =
      //     this.selectedItems.indexOf(this.prescriptions[i]) < 0 ? false : true;
      //   this.tSelectedItems.push(item);
      // }
      // //this.tSelectedItems = this.selectedItems;
      this.dlgShow = true;
    },
    selectAll() {
      for (let i = 0; i < this.prescriptions.length; i++) {
        this.prescriptions[i].Selected = true;
      }
    },
    selectNone() {
      for (let i = 0; i < this.prescriptions.length; i++) {
        this.prescriptions[i].Selected = false;
      }
    },
    closeDlg() {
      this.dlgShow = false;
    },
    saveDlg() {
      this.dlgShow = -false;
      this.selectedItems = [];
      for (let i = 0; i < this.prescriptions.length; i++) {
        if (this.prescriptions[i].Selected)
          this.selectedItems.push(this.prescriptions[i].Item);
      }
    }
  }
};
</script>

<style scoped>
.permList {
  //height: 200px;
  border: 1px solid lightgray;
  //overflow: auto;
}
</style>
